import EmptyCastCrewShell from './empty-cast-crew-shell';
import AddCrewModal from './add-crew-modal/add-crew-modal';
import { useAppSelector } from '@/store/hooks';
import { selectSpeakers } from '@/store/slices/speakers/selectors';
import useSelectSessionCrew from '../helpers/use-select-session-crew';

const EmptyCrew = () => {
  const speakers = useAppSelector(selectSpeakers);
  const crew = useSelectSessionCrew();

  if (speakers && crew.length) return null;
  return (
    <EmptyCastCrewShell
      loading={!speakers}
      title="Staff Mission Control"
      description="Add producers to keep every moment running smoothly."
    >
      <AddCrewModal />
    </EmptyCastCrewShell>
  );
};

export default EmptyCrew;
